import ReactGA from 'react-ga4';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import { globals } from '../config/globals';
import 'assets/style/style.scss';
import { purgeLocalStorage } from 'helpers/utilities';
import { I18nextProvider } from 'react-i18next';
import LanguageServiceConfig from './services/LanguageService/LanguageService';
import App from 'components/App';
import * as Sentry from '@sentry/react';
ReactGA.initialize(process.env.GA4_MEASUREMENT_ID);
window.globals = globals;
purgeLocalStorage();
var isLocal = process.env.NODE_ENV === 'none' || process.env.NODE_ENV === undefined;
var isProduction = process.env.NODE_ENV === 'production';
var sentryEnv = isProduction ? 'production' : 'development';
Sentry.init({
    dsn: process.env.SENTRY_DSN,
    enabled: !isLocal,
    environment: sentryEnv,
    integrations: [Sentry.replayIntegration()],
    release: '',
    sampleRate: isProduction ? 0.1 : 1,
    tracesSampleRate: isProduction ? 0.1 : 1,
    replaysSessionSampleRate: isProduction ? 0.1 : 0,
    replaysOnErrorSampleRate: isProduction ? 1.0 : 0
});
var root = createRoot(document.getElementById('app'));
root.render(React.createElement(I18nextProvider, { i18n: LanguageServiceConfig },
    React.createElement(Suspense, { fallback: "loading" },
        React.createElement(Provider, { store: store },
            React.createElement(App, null)))));
